// Scoring + title logic for Marketing Trail

export function clamp(n, lo = 0, hi = 100) {
  return Math.max(lo, Math.min(hi, n));
}

export function applyDeltas(stats, deltas) {
  const next = { ...stats };
  for (const k of Object.keys(deltas)) {
    if (k === "budget") {
      next.budget = Math.max(0, (next.budget || 0) + deltas.budget);
    } else {
      next[k] = clamp((next[k] || 0) + deltas[k]);
    }
  }
  return next;
}

export function calcFinalScore(stats, startingBudget) {
  const remainingBudgetScore = startingBudget > 0
    ? clamp(Math.round((stats.budget / startingBudget) * 100))
    : 0;
  const weights = {
    awareness: 0.18,
    trust: 0.20,
    leads: 0.22,
    energy: 0.12,
    systems: 0.20,
    budget: 0.08,
  };
  const raw =
    stats.awareness * weights.awareness +
    stats.trust * weights.trust +
    stats.leads * weights.leads +
    stats.energy * weights.energy +
    stats.systems * weights.systems +
    remainingBudgetScore * weights.budget;
  return Math.round(clamp(raw));
}

export function pickStrongestWeakest(stats) {
  const keys = ["awareness", "trust", "leads", "energy", "systems"];
  const sorted = [...keys].sort((a, b) => stats[b] - stats[a]);
  return { strongest: sorted[0], weakest: sorted[sorted.length - 1] };
}

export function pickTitle({ score, stats, bootstrap }) {
  const { strongest, weakest } = pickStrongestWeakest(stats);
  if (bootstrap && score >= 55) return "Bootstrap Hero";
  if (score >= 80) return "Marketing Trailblazer";
  if (stats.systems >= 70 && stats.trust >= 60) return "Strategic Settler";
  if (stats.trust >= 70 && stats.awareness < 50) return "Trusted but Hidden";
  if (stats.awareness >= 70 && stats.leads < 45) return "Famous but Broke";
  if (stats.energy < 35) return "Burned-Out Boss";
  if (stats.systems < 35) return "Random Acts of Marketing Survivor";
  if (strongest === "awareness" && weakest === "systems") return "Algorithm Casualty";
  if (stats.systems >= 60 && stats.leads >= 60) return "Website Wagon Warrior";
  return "Trail Survivor";
}

export function statLabel(k) {
  return {
    awareness: "Awareness",
    trust: "Trust",
    leads: "Leads",
    energy: "Energy",
    systems: "Systems",
    budget: "Budget",
  }[k] || k;
}

export function recap({ stats, bootstrap, businessName }) {
  const { strongest, weakest } = pickStrongestWeakest(stats);
  const opener = bootstrap
    ? `You went broke but you kept moving. ${businessName || "Your business"} survived the trail through grit and clever low-cost moves.`
    : `You survived the Marketing Trail. ${businessName || "Your business"} made it through the first year.`;
  return `${opener} Your strongest area was ${statLabel(strongest).toLowerCase()}, while ${statLabel(
    weakest
  ).toLowerCase()} was your weakest. With a clearer plan, you can improve your trail score next time.`;
}

export function rollEvent(month, supplies) {
  // Random event probability: ~55%, more likely after month 3
  if (month < 3) return null;
  if (Math.random() > 0.55) return null;
  return null; // chosen externally
}
